var _g, _g2, _line, _line2, _line3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupTrainSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e3QZgB1kPwM1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.000001 0.000001)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.498372,
    ry: 4.498372,
    transform: "translate(8.564248 11.195331)",
    fill: "none",
    stroke: "#7c868a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.539553 1.034142)",
    clipPath: "url(#e3QZgB1kPwM6)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.498372,
    ry: 4.498372,
    transform: "matrix(1.315353 0 0 1.349817 9.103801 21.492651)",
    fill: "none",
    stroke: "#7c868a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "e3QZgB1kPwM6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 2.4,
    rx: 0,
    ry: 0,
    transform: "matrix(11.764944 0 0 3.239275-7.344395 13.718391)",
    fill: "#d2dbed",
    strokeWidth: 0
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.939097 0 0 0.9391 24.363404 0.855435)",
    clipPath: "url(#e3QZgB1kPwM10)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.977908,
    height: 21.19082,
    rx: 2,
    ry: 2,
    transform: "matrix(.935731 0 0 1-23.447905 1.098057)",
    fill: "none",
    stroke: "#7c868a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "e3QZgB1kPwM10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0h21.433001v40.176331l-6.87603-.749387v-4.920867L3.484032,20.964767h-3.484032L0,0Z",
    transform: "matrix(1.316381 0 0 0.888722-27.272198-10.336715)",
    fill: "#d2dbed",
    strokeWidth: 0
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: -2.33806,
    y1: 2.630318,
    x2: 4.858887,
    y2: -5.568901,
    transform: "matrix(.965691-.259694 0.259694 0.965691 16.003543 18.639664)",
    fill: "none",
    stroke: "#7c868a",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: -2.33806,
    y1: 2.630318,
    x2: 5.790885,
    y2: 4.816355,
    transform: "matrix(.965691-.259694 0.259694 0.965691 12.915578 1.753408)",
    fill: "none",
    stroke: "#7c868a",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0.107424,
    y1: 3.287959,
    x2: 5.790885,
    y2: 4.816355,
    transform: "matrix(.965691-.259694 0.259694 0.965691 12.88666 4.785076)",
    fill: "none",
    stroke: "#7c868a",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupTrainSm);
export default __webpack_public_path__ + "static/media/group_train_sm.49e5182e673e54c156d91cff0788d292.svg";
export { ForwardRef as ReactComponent };